import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
const createSelectors = (parentReducer) => {
    return new (class {
        selectUsers = (store) => {
            const reducer = store["MainReducer"];

            return reducer.users;
        };
        selectReportTypes = (store) => {
            const pageReducer = store[parentReducer];
            const reducer = pageReducer["ReportMapWidget_reducer"];
            return reducer.report_types;
        };
        selectUsernames = createSelector(
            [this.selectUsers],
            (users = false) => {
                let usernames = {};
                if (users) {
                    Object.keys(users).map((uid) => {
                        if (!users[uid].profile.deleted)
                            usernames = _.assign(usernames, {
                                [uid]:
                                    users[uid].profile.first_name +
                                    " " +
                                    users[uid].profile.last_name,
                            });
                        return null;
                    });
                    return usernames;
                } else return false;
            }
        );
        selectReports = createSelector([this.selectUsers], (users = false) => {
            if (users) {
                let reports = {};
                let date = moment();
                let month = moment(date).format("MMM").toLowerCase();
                let year = moment(date).format("YYYY");
                Object.keys(users).map((uid) => {
                    let receipts = _.get(users[uid], "receipts") || false;
                    if (receipts) {
                        let rptY = receipts[year] ? receipts[year] : false;
                        let rptM = rptY ? rptY[month] : false;
                        let rpt = rptM ? rptM : false;

                        rpt &&
                            Object.keys(rpt).map((type) => {
                                Object.keys(rpt[type]).map((ts) => {
                                    reports = _.assign(reports, {
                                        [ts]: { ...rpt[type][ts], uid },
                                    });
                                    return null;
                                });
                                return null;
                            });
                    }
                    return null;
                });
                return reports;
            } else return false;
        });
    })();
};

export default createSelectors;
